export default () => ({
  distRight: 0,
  height: 0,
  thumbWidth: 0,
  scrollPos: 0,
  mousePosition: 0,

  //dragging the scrollbar thumb
  thumbScroll(e) {
    this.mousePosition = e.clientX;
    document.onmouseup = this.closeDragElement;
    const initPos = this.scrollPos;
    document.body.classList.toggle('no-drag');
    document.onmousemove = (event) => {
      this.dragThumb(event, this.mousePosition, initPos);
    };
  },

  dragThumb(e, mousePosition, initPos) {
    const dir = mousePosition > e.clientX ? -1 : 1;
    const mouseMove = Math.abs(mousePosition - e.clientX);
    let pos =
      (mouseMove / this.$el.parentElement.offsetWidth) * 100 * dir + initPos;
    this.scrollPos = Math.min(Math.max(pos, 0), 100 - this.thumbWidth);

    this.scrollContent(this.$el.parentElement.previousElementSibling);
  },

  //moves content when not scrolled natively
  scrollContent(scrollElement) {
    scrollElement.scrollLeft =
      ((scrollElement.scrollWidth - this.distRight) * this.scrollPos) / 100;
  },

  //removes event listeners
  closeDragElement() {
    document.onmouseup = null;
    document.onmousemove = null;
    document.body.classList.toggle('no-drag');
  },

  //native mouse scroll, moves thumb
  mouseScroll(e) {
    this.scrollPos =
      (e.target.scrollLeft / (this.$el.scrollWidth - this.distRight)) * 100;
  },

  //mouse drag over content
  mouseDrag(e) {
    document.body.classList.toggle('no-drag');
    const images = document.querySelectorAll('[data-fancybox]');
    let initPos = e.pageX;

    //remove event listeners
    document.onmouseup = () => {
      this.closeDragElement();
      this.$nextTick(() => {
        images.forEach((image) => {
          image.onclick = null;
        });
      });
    };

    //move content
    document.onmousemove = (event) => {
      let pos =
        ((this.$el.scrollLeft + (initPos - event.pageX)) /
          (this.$el.scrollWidth - this.distRight)) *
        100;
      initPos = event.pageX;
      this.scrollPos = Math.min(Math.max(pos, 0), 100 - this.thumbWidth);
      this.scrollContent(this.$el);

      //prevent fancybox gallery from opening
      images.forEach((image) => {
        image.onclick = (event) => {
          event.preventDefault();
        };
      });
    };
  },

  init() {
    const rect = this.$el.getBoundingClientRect();
    this.distRight = window.innerWidth - (rect.left + rect.width);
    this.height = this.$el.firstElementChild.getBoundingClientRect().height;
    this.$nextTick(() => {
      this.thumbWidth =
        (rect.width /
          (this.$el.firstElementChild.scrollWidth - this.distRight)) *
        100;
    });
  },
});
